import { useState } from 'react';

import useOnMount from './useOnMount';

/**
 * Simple hook which will indicate that a given component has mounted.
 * You mostly shouldn't _need_ to use this, however it is useful in
 * narrow situations where you need to know if it's the initial render,
 * or if you're doing cleanup and want to ensure the component still exists.
 *
 * Inspired by: https://usehooks-ts.com/react-hook/use-is-mounted
 *
 * @example
 * const MyComponent = ({ children }) => {
 *   const isMounted = useHasMounted();
 *   return isMounted ? children : <Loading />;
 * };
 */
const useHasMounted = (): boolean => {
  const [hasMounted, setHasMounted] = useState(false);

  useOnMount(() => {
    setHasMounted(true);
  });

  return hasMounted;
};

export default useHasMounted;
